import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Chefs from "@/pages/Chefs";
import ChefDetail from "@/pages/ChefDetail";
import Menus from "@/pages/Menus";
import MenuDetail from "@/pages/MenuDetail";
import ChefsTable from "@/pages/ChefsTable";
import ChefsTableDetail from "@/pages/ChefsTableDetail";
import CityChefs from "@/pages/CityChefs";
import Diwali from "@/pages/Diwali";
import MyBookings from "@/pages/MyBookings";
import ChefPortal from "@/pages/ChefPortal";
import AdminPortal from "@/pages/AdminPortal";
import ProfileCallback from "@/pages/ProfileCallback";
import Terms from "@/pages/Terms";
import BlackMembership from "@/pages/BlackMembership";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App min-h-screen">
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/chefs" element={<Chefs />} />
              <Route path="/chefs/:id" element={<ChefDetail />} />
              <Route path="/menus" element={<Menus />} />
              <Route path="/menus/:id" element={<MenuDetail />} />
              <Route path="/chefs-table" element={<ChefsTable />} />
              <Route path="/chefs-table/:id" element={<ChefsTableDetail />} />
              <Route path="/private-chef-mumbai" element={<CityChefs city="mumbai" />} />
              <Route path="/private-chef-bengaluru" element={<CityChefs city="bengaluru" />} />
              <Route path="/private-chef-indore" element={<CityChefs city="indore" />} />
              <Route path="/private-chef-delhi-ncr" element={<CityChefs city="delhi-ncr" />} />
              <Route path="/private-chef-hyderabad" element={<CityChefs city="hyderabad" />} />
              <Route path="/diwali" element={<Diwali />} />
              <Route path="/my-bookings" element={<MyBookings />} />
              <Route path="/chef" element={<ChefPortal />} />
              <Route path="/admin" element={<AdminPortal />} />
              <Route path="/profile" element={<ProfileCallback />} />
              <Route path="/membership" element={<BlackMembership />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#141414",
              color: "#FDFDFD",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 2,
            },
          }}
        />
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
